<template>
  <v-dialog v-model="dialog" persistent max-width="500" style="z-index:99;" scrollable transition="dialog-bottom-transition" :overlay="false">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon @click.native="close()" dark>
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title :class="`${arabic?'arFont':'enFont'}`">رد لهذا الموضوع</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click.native="close()" :class="`${arabic?'arFont':'enFont'}`">اغلاق</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-row class="align-center"> 
          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
            <v-textarea
              label="الرد"
              outlined
              hide-details
              dense
              v-model="resource.text"
              :class="`${arabic?'arFont':'enFont'}`"
            ></v-textarea>
          </v-col>
          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
            ملاحظة: سيظهر اسمك مرفقاً بالرد
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :class="`${arabic?'arFont':'enFont'}`" @click="postResource()" :disabled="!resource.text">
          اضافة رد جديد
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {firebase, db, auth, store} from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: {},
  props:['dialog'],
  data(){
    return {
      resource:{},
    }
  },
  methods: {
    close() {
      this.$emit('closeDialog')
    },
    postResource(){
      this.$emit('postResource', this.resource)
    },
  },
  watch:{
    
  },
  computed:{
    progress(){
      return (this.visible + this.prev_progress)/69 * 100
    },
    questions(){
      return this.quiz
    },
    cc(){
      return this.$store.state.cc
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      const items = [...this.$store.state.modelMenu]
      let user = {...this.$store.state.user}
      let role = user.role
      this.$store.menu = items.map(x=>{
        if(x.subs) {
          return {
            ...x, 
            subs:x.subs.filter(x=>x&&x.roles.includes(role))
          }
        } else if(x&&x.roles.includes(role)) {
          return {
            ...x
          }
        }
      }).filter(x=>x&&x.roles.includes(role))
      return this.$store.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications
    },
    // countries(){
    //   return this.$store.state.countries
    // },
    country(){
      return this.$store.state.country
    },
  },
  mounted(){
  },
  created(){
  }
}
</script>
